import { render, staticRenderFns } from "./PBRMappingForm.vue?vue&type=template&id=4c6e2306&"
import script from "./PBRMappingForm.vue?vue&type=script&lang=js&"
export * from "./PBRMappingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports